<section class="location section-padding" id="location">
  <div class="container text-center">
    <h2 class="title">Perto de tudo o que importa</h2>
    <p class="subtitle">No coração da Bela Vista, em São Paulo</p>
    <p class="description">
      A Casa Alta está na Bela Vista, uma das regiões mais centrais e acessíveis de São Paulo – vizinha da Avenida Paulista, Avenida Nove de Julho e do Hotel Rosewood. A localização é estratégica para receber convidados que vêm de diferentes pontos da cidade, independente da forma de locomoção, próprio ou privado.
    </p>
    <p class="description">
      Ao confirmar sua reserva, você recebe o endereço completo e um link com mapa e instruções personalizadas para compartilhar com convidados, equipe e fornecedores, facilitando a logística do seu evento.
    </p>
  </div>

  <div class="video-container">
<video id="locationVideo" muted loop playsinline preload="auto">
  <source src="/assets/videos/Edwardian-Drone-HD.webm" type="video/webm" />
</video>
  </div>
</section>
